module.exports = __webpack_public_path__ + "media/images/product/m_c-370c521b58f2db3bfaf4bfdbe51e228e.png";